import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { getExportInfo } from "../../slices/export";

const translations = [
    gettext('Dashboard'),
    gettext('Subscriptions'),
    gettext('Payments'),
    gettext('Customers'),
    gettext('Transactions'),
    gettext('Plans'),
    gettext('Analytics'),
    gettext('Export'),
    gettext('Settings'),
    gettext('Logout'),
]

import * as Svg from "../svg";

export const Sidebar = (props) => {
    const dispatch = useDispatch()
    const exportInfo = useSelector((state) => state.export.exportInfo);

    const [collapsed, setCollapsed] = useState(false);

    // useEffect(() => {
    //    setInterval(() => dispatch(getExportInfo()), 3000);
    // }, [])

    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, [props.initialCollapsed]);

    const handleResize = () => {
        if (window.innerWidth < 992 && window.innerWidth > 768) {
            setCollapsed(true);
        } else {
            setCollapsed(props.initialCollapsed);
        }
    }

    const collapseHandler = () => {
        setCollapsed(!collapsed)
        props.collapseHandler()
    }

    return (
        <div className={`sidebar ${collapsed ? 'sidebar-collapsed' : ''}`}>
            <div className={`collapse-handler d-none d-md-block ${collapsed ? 'collapsed' : ''}`} onClick={() => collapseHandler()}>
                <Svg.SvgArrow />
            </div>
            <div className="logo">
                <NavLink className="nav-link" to="/">
                    <Svg.SvgLogo />
                </NavLink>
            </div>
            <div className="sidebar__menu">
                <ul className="nav nav-pills flex-column">
                    <li className="nav-item">
                        <NavLink className="nav-link" to="/">
                            <span className="text">{gettext('Dashboard')}</span>
                            <span className="icon"><Svg.SvgDashboard /></span>
                        </NavLink>
                    </li>
                    <li className="nav-item" data-tour="subscription-button">
                        <NavLink className="nav-link" to="/subscriptions">
                            <span className="text">{gettext('Subscriptions')}</span>
                            <span className="icon"><Svg.SvgSubscriptions /></span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="nav-link" to="/payments">
                            <span className="text">{gettext('Payments')}</span>
                            <span className="icon"><Svg.SvgSinglePayments /></span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="nav-link" to="/customers">
                            <span className="text">{gettext('Customers')}</span>
                            <span className="icon"><Svg.SvgCustomers /></span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="nav-link" to="/transactions">
                            <span className="text">{gettext('Transactions')}</span>
                            <span className="icon"><Svg.SvgTransactions /></span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="nav-link" to="/plans">
                            <span className="text">{gettext('Plans')}</span>
                            <span className="icon"><Svg.SvgPlans /></span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="nav-link" to="/analytics">
                            <span className="text">{gettext('Analytics')}</span>
                            <span className="icon"><Svg.SvgAnalytics /></span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="nav-link" to="/export">
                            <span className="text">{gettext('Export')}</span>
                            { exportInfo.pending &&                             
                                <span className={`export pending ms-auto ${ exportInfo.total_unfetched === 0 ? "me-5" : ""}`}>
                                    <div className="spinner spinner-border me-3" role="status"></div>
                                </span>
                            }
                            { exportInfo.total_unfetched > 0 &&
                                <span className="export unfetched dot d-flex align-items-center justify-content-center">
                                    <span className="num">{ exportInfo.total_unfetched }</span>
                                </span>
                            }
                            <span className="icon"><Svg.SvgExport /></span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="nav-link" to="/settings">
                            <span className="text">{gettext('Settings')}</span>
                            <span className="icon"><Svg.SvgSettings /></span>
                        </NavLink>
                    </li>
                    <li className="nav-item d-block d-md-none">
                        <a className="nav-link" href="/accounts/logout">
                            <span className="text"><div className="topbar_logout" onClick={() => doLogout()}>{gettext('Logout')}</div></span>
                            <span className="icon"><Svg.SvgLogout /></span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>

    )
}


Sidebar.propTypes = {
    initialCollapsed: PropTypes.bool,
    collapseHandler: PropTypes.func,
};

Sidebar.defaultProps = {
    initialCollapsed: false,
    collapseHandler: () => { },
};